import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '../Icon';
import prefix from '../../utils/prefix';
import './styles.sass';
import { extractMessageFromError } from '../../utils/errorUtil';
var modifiers = prefix('content-error--');
var ContentError = function ContentError(_ref) {
  var title = _ref.title,
    error = _ref.error,
    large = _ref.large,
    onRetryClick = _ref.onRetryClick;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('content-error', modifiers({
      large: large
    }))
  }, /*#__PURE__*/React.createElement(Icon, {
    material: true,
    name: "error outline",
    color: "#F44336",
    large: true
  }), /*#__PURE__*/React.createElement("h3", {
    className: "title is-3 content-error__title"
  }, title), error && /*#__PURE__*/React.createElement("div", {
    className: "content-error__error"
  }, extractMessageFromError(error)), onRetryClick && /*#__PURE__*/React.createElement("div", {
    className: "content-error__retry-container"
  }, /*#__PURE__*/React.createElement("a", {
    className: "button is-danger is-outlined",
    onClick: function onClick(e) {
      return e.preventDefault() || onRetryClick();
    }
  }, "Retry")));
};
ContentError.propTypes = {
  title: PropTypes.string,
  error: PropTypes.any,
  large: PropTypes.bool,
  onRetryClick: PropTypes.func
};
ContentError.defaultProps = {
  title: 'An error occurred'
};
export default ContentError;
//# sourceMappingURL=index.js.map
